import React, { useState } from "react";
import Select from "react-select";
import SampleModal from "./SampleModal"; // Import the new modal component
import MathGraphGeneratorModal from "./mathgenmodal";

const NavBar = ({
  handleUpdate,
  handleSoftReset,
  handleReset,
  handleautofill,
  handleGraphModal,
  selectedSkill,
  onSkillChange,
  selectedDifficulty,
  onDifficultyChange,
}) => {
  const [isSampleModalOpen, setIsSampleModalOpen] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  const difficultyOptions = [
    { value: "E", label: "Easy" },
    { value: "M", label: "Medium" },
    { value: "H", label: "Hard" },
  ];

  const [msubjects, msetSubjects] = useState([
    {
      name: 'Algebra', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Linear functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Systems of two linear equations in two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Linear inequalities in one or two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Linear equations in one variable', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Linear equations in two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Advanced Math', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Nonlinear functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Equivalent expressions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Nonlinear equations in one variable and systems of equations in two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Problem-solving and Data Analysis', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Ratios, rates, proportional relationships, and units', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Inference from sample statistics and margin of error', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Probability and conditional probability', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Percentages', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'One-variable data: Distributions and measures of center and spread', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Two-variable data: Models and scatterplots', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Evaluating statistical claims: Observational studies and experiments', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Geometry and Trigonometry', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Lines, angles, and triangles', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Right triangles and trigonometry', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Area and volume', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Circles', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    }
  ]);

  const openSampleModal = () => {
    setIsSampleModalOpen(true);
  };

  const closeSampleModal = () => {
    setIsSampleModalOpen(false);
  };

  return (
    <>
      <MathGraphGeneratorModal
        visible={modalVisible}
        onClose={hideModal}
      />

      <nav className="bg-slate-700 text-white p-4 flex justify-between items-center">
        {/* 왼쪽: SAT 및 Select box */}
        <div className="flex items-center gap-4">
          <div className="text-xl font-bold">SAT</div>
          <button
            className="bg-slate-600 p-2 rounded-lg"
            onClick={openSampleModal}
          >
            Load Sample
          </button>
        </div>

        {/* 오른쪽 버튼 그룹 */}
        <div className="flex gap-4">
          <button
            className="bg-slate-600 p-2 rounded-lg"
            onClick={() => handleautofill()}
          >
            Auto Fill
          </button>
          <button className="bg-slate-600 p-2 rounded-lg" onClick={handleUpdate}>
            Update
          </button>
          <button
            className="bg-slate-600 p-2 rounded-lg"
            onClick={handleSoftReset}
          >
            Soft Reset
          </button>
          <button className="bg-slate-600 p-2 rounded-lg" onClick={handleReset}>
            Reset
          </button>
          <button
            className="bg-slate-600 p-2 rounded-lg"
            onClick={handleGraphModal}
          >
            Eng Graph
          </button>

          <button
            className="bg-slate-600 p-2 rounded-lg"
            onClick={showModal}
          >
            Math Graph
          </button>
        </div>
      </nav>

      {/* Sample Modal */}
      <SampleModal
        isOpen={isSampleModalOpen}
        onClose={closeSampleModal}
        subjects={msubjects}
      />
    </>
  );
};

export default NavBar;